<template>
  <b-card style="padding:40px;">
    <h5><b>OUTLET HISTORY NAME</b></h5>
    <hr />
    <b-row class="my-1">
      <b-col sm="6">
        <label for="input-default"
          >Outlet Name<span class="danger-new"> *</span></label
        >
        <b-form-input v-model="form.outlet_user_id" hidden />
        <b-form-input
          v-model="form.outlet_name"
          id="input-horizontal"
          class="input-new"
        />
        <p v-if="error.name">
          <span class="danger-new">{{ this.error.name }}</span>
        </p>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Fax No.</label>
          <b-form-input
            v-model="form.faxno"
            type="text"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Tel No.</label>
          <b-form-input
            v-model="form.telno"
            type="text"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`">Address 1</label>
          <b-form-input
            v-model="form.add1"
            type="text"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`">Address 2</label>
          <b-form-input
            v-model="form.add2"
            type="text"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`">Address 3</label>
          <b-form-input
            v-model="form.add3"
            type="text"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`">Notes</label>
          <b-form-textarea
            v-model="form.notes"
            class="input-new"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col sm="4" style="padding-top:27px;">
        <b-button variant="primary" size="m" @click="onClickAdd">+</b-button
        >&nbsp;
        <b-button variant="danger" size="m" @click="onClickClear">x</b-button
        >&nbsp;
      </b-col>
    </b-row>

    <br />
    <br />
    <br />
    <TableOutletIndex
      :fields="fields.fields"
      :refresh="refreshTable"
      @edit="onEdit($event)"
    />
  </b-card>
</template>

<script>
import TableOutletIndex from "@/table/user/outlet/TableOutletIndex";

export default {
  data() {
    return {
      items: [],
      refreshTable: false,
      form: {
        outlet_user_id: null,
        outlet_name: "",
        faxno: "",
        telno: "",
        add1: "",
        add2: "",
        add3: "",
        notes: ""
      },
      error: {
        name: ""
      },
      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Outlet Name",
            key: "outlet_name",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  created() {
    // this.getOutlet()
  },
  methods: {
    onClickAdd() {
      this.error.name = "";
      this.checkForm();

      this.$store.dispatch("createOutletNameHistory", this.form).then(res => {
        if (res.data.response.code === 1) {
          this.form = {
            outlet_name: "",
            outlet_user_id: null,
            faxno: "",
            telno: "",
            add1: "",
            add2: "",
            add3: "",
            notes: ""
          };
          this.refreshTable = true;
        } else {
          this.error.name = "Unsuccessful update !! ";
        }
      });
    },
    checkForm: function(e) {
      if (this.form.outlet_name) return true;
      this.error.name = "";
      if (!this.form.outlet_name) this.error.name = "Outlet Name required.";
      e.preventDefault();
    },

    onEdit(index) {
      this.form = {
        outlet_name: index.outlet_name,
        outlet_user_id: index.outlet_user_id,
        faxno: index.faxno,
        telno: index.telno,
        add1: index.add1,
        add2: index.add2,
        add3: index.add3,
        notes: index.notes
      };
    },
    onClickClear() {
      this.form.outlet_user_id = null;
      this.form.outlet_name = null;
      this.form.faxno = null;
      this.form.telno = null;
      this.form.add1 = null;
      this.form.add2 = null;
      this.form.add3 = null;
      this.form.notes = null;
    }
  },
  components: {
    TableOutletIndex
  }
};
</script>
<style lang="css" scoped></style>
